'use client';

import { QueryCGType } from '@/types/graphql/root';
import { getSavedPois } from '@/utils/actions';
import chunk from 'lodash/chunk';
import { useCallback, useMemo, useState } from 'react';
import SavedPoiCard from './saved-poi-card';
import SpinnerLoader1818 from '@svg/common/spinner_loader_18_18.svg';
import { filterNullUndefined } from '@/utils';

export default function SavedPoisMoreContainer({ endCursorId: initEndCursorId }: { endCursorId: string }) {
  const [hasNextPage, setHasNextPage] = useState(true);
  const [endCursorId, setEndCursorId] = useState(initEndCursorId);
  const [serverLoading, setServerLoading] = useState(false);
  const [morePois, setMorePois] = useState<QueryCGType['savedPois']['edges'][0]['node'][]>([]);

  const chunkedSavedPois = useMemo(() => {
    return chunk(morePois, 3);
  }, [morePois]);

  const onClickMoreSavedPois = useCallback(async () => {
    try {
      setServerLoading(true);
      const savedPois = await getSavedPois(15, endCursorId);
      if (savedPois?.pageInfo.hasNextPage === false) setHasNextPage(false);
      if (savedPois?.pageInfo.endCursorId) setEndCursorId(savedPois?.pageInfo.endCursorId);
      setMorePois((prev) => [...prev, ...filterNullUndefined(savedPois?.edges.map((edge) => edge.node))]);
    } catch (error) {
      console.error(error);
    } finally {
      setServerLoading(false);
    }
  }, [endCursorId]);

  return (
    <>
      {chunkedSavedPois.length > 0 &&
        chunkedSavedPois.map((savedPois, index) => (
          <div
            key={'chunked-saved-pois-more-row_' + index}
            className='flex border-t border-gray-200 gap-14pxr py-24pxr first:pt-0'
          >
            {savedPois.map((savedPoi) => (
              <SavedPoiCard key={'savedPoiCard_' + savedPoi.id} poi={savedPoi} />
            ))}
          </div>
        ))}
      {serverLoading && (
        <div className='w-full my-24pxr flex items-center justify-center h-20pxr'>
          <SpinnerLoader1818 className='animate-spin' />
        </div>
      )}
      {!serverLoading && hasNextPage && (
        <button
          className='w-full my-24pxr button-16-m text-center text-primary h-20pxr'
          onClick={() => {
            onClickMoreSavedPois();
          }}
        >
          더보기
        </button>
      )}
    </>
  );
}
